import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./auth";
import { installRuntimeErrorReporting, RuntimeErrorBoundary } from "./runtime-errors";

installRuntimeErrorReporting();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RuntimeErrorBoundary><AuthProvider><App /></AuthProvider></RuntimeErrorBoundary>
  </StrictMode>
);
